<iframe src="" style="display: none;" id="iframe"></iframe>

<div class="tile-progress bg-white text-left">
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
      <label>Select Date Range</label>
      <ngx-mat-drp (selectedDateRangeChanged)="updateRange($event)" [options]="options" #dateRangePicker>
      </ngx-mat-drp>
    </div>

    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" *ngIf="landingFrom!='dhp'">
      <label>Select Account</label>
      <ng-select #filterAccount name="accounts" placeholder="Select account" bindLabel="accountName" bindValue="accountId"
        [items]="accounts" [clearable]="true" [searchable]="true" [(ngModel)]="accountId"
        (change)="updateSelectedAccount()">
      </ng-select>
    </div>

    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" *ngIf="accountId !== null">
      <label>Select Screening Center</label>
      <ng-select #filterScreeningCenter name="screeingcenters" placeholder="Select screening center" bindLabel="orgName"
        bindValue="orgId" [items]="screeningCenters" [clearable]="true" [searchable]="true" [(ngModel)]="orgId"
        (change)="getIncentiveReportsByAccountOrgId()">
      </ng-select>
    </div>
    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-1" *ngIf="accountId !== null">
      <button [disabled]="incentiveReports==null || incentiveReports.length<1" tooltip="Export to Excel" (click)="downloadXLS()" class="btn btn-sm btn-success marginLR5 pull-right" style="margin-top:30px;">
        <i class="fa fa-fw fa-lg fa-file-excel-o"></i></button>
    </div>
    
  </div>
</div>

<div *ngIf="accountId!=null">
  <div class="card-header">
    Incentives Report
    <!-- <button class="btn btn-sm btn-success pull-right" (click)="exportIncentiveReport()" data-toggle="tool-tip"
      title="Export excel"><i class="fa fa-file-excel-o"></i></button> -->
  </div>
  <div class="content-body padding-top-20 padding-bottom-20">
    <div class="row">
      <p-table [value]="incentiveReports" sortMode="multiple"
        [paginator]="incentiveReports!=null && incentiveReports.length>0" [rows]="10" #dt>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 75px;text-align: center;">
              #
            </th>
            <th>Customer Details
            </th>
            <th>User Type
            </th>
            <th>Bank Details
            </th>
            <th>Incentive/Rewards
            </th>
          </tr>
          <tr *ngIf="incentiveReports==null || incentiveReports.length==0" style="background: #fff5f3;">
            <td colspan="5">
              <div style="padding: 5px;text-align: center;">
                No record found
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-incentive let-i="rowIndex">
          <tr style="cursor: pointer;">
            <td style="text-align: center;">
              {{ i + 1}}
            </td>
            <td>
              <span style="font-weight: bold;display: inline-block;
              min-width: 50px;">Name&nbsp;</span>:&nbsp;{{incentive.fullName}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 50px;">Email&nbsp;</span>:&nbsp;{{incentive.email}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 50px;">Mobile&nbsp;</span>:&nbsp;{{incentive.phoneNo}}
            </td>
            <td>
              {{getUserTypeString(incentive.userType)}}
            </td>
            <td>
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Account No&nbsp;</span>:&nbsp;{{incentive.userAdditionalDetails.accountNumber}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Accountholder
                Name&nbsp;</span>:&nbsp;{{incentive.userAdditionalDetails.accountHolderName}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Bank Name&nbsp;</span>:&nbsp;{{incentive.userAdditionalDetails.bankName}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">IFSC Code&nbsp;</span>:&nbsp;{{incentive.userAdditionalDetails.ifscCode}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Branch Address&nbsp;</span>:&nbsp;{{incentive.userAdditionalDetails.branchAddress}}
            </td>
            <td>
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Free Refraction
                Units&nbsp;</span>:&nbsp;{{incentive.totalFreeRefractionUnits}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Refraction
                Units Purchased&nbsp;</span>:&nbsp;{{incentive.totalRefractionPurchased}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Recharge Amount&nbsp;</span>:&nbsp;{{incentive.currency === 'INR' ? '₹' : (incentive.currency === 'USD' ? '$' : null)}}&nbsp;{{incentive.totalRechargeAmount |
              number : '.2-2'}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Refraction Report
                Generated&nbsp;</span>:&nbsp;{{incentive.totalPrescriptionsGenerated}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Available Refraction
                Units&nbsp;</span>:&nbsp;{{incentive.totalRefractionsUnitsRemaining}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">No Of Registered
                Referrals&nbsp;</span>:&nbsp;{{incentive.noOfRegisteredReferrals}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Rewards&nbsp;</span>:&nbsp;{{incentive.totalRewards}}
              <br />
              <span style="font-weight: bold;display: inline-block;
              min-width: 200px;">Payout Amount&nbsp;</span>:&nbsp;{{incentive.currency === 'INR' ? '₹' : (incentive.currency === 'USD' ? '$' : null)}}&nbsp;{{incentive.totalPayoutAmount | number
              : '.2-2'}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>